// This helper function appends "?f=xu" to IKEA product image URLs to receive an 80x80 pixel image.
// For more information regarding different sizes, see https://uth.ingka.com/articles/image-optimization-on-ikeacom/

export const getSmallThumbnailImageUrl = (url: string): string => {
  if (!url) return "";

  try {
    const urlObj = new URL(url);

    const isIkeaHostname = /(^|\.)ikea\./i.test(urlObj.hostname);
    if (!isIkeaHostname || !urlObj.pathname.toLowerCase().endsWith(".jpg")) {
      return url;
    }

    urlObj.searchParams.set("f", "xu");
    return urlObj.toString();
  } catch {
    return url;
  }
};
